'use client'
import * as React from 'react'
import { useTranslations } from 'next-intl'
import dynamic from 'next/dynamic'

const SeeAllModal = dynamic(
  () => import('./see-all-content').then(module => module.SeeAllContent),
  {
    ssr: false,
  },
)

export function SeeAllLink() {
  const t = useTranslations('prod.product_description_page.buy')
  const [isOpen, setIsOpen] = React.useState(false)
  return (
    <>
      <button
        tabIndex={0}
        className="text-cf-link cursor-pointer whitespace-nowrap underline hover:no-underline"
        onClick={() => {
          setIsOpen(true)
        }}
      >
        {t('see_all')}
      </button>
      {isOpen ? <SeeAllModal isOpen={isOpen} setIsOpen={setIsOpen} /> : null}
    </>
  )
}
